module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7GLoD"))).then(() => parcelRequire('dJXJK'));